import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { getItem, GET_INFO } from 'utils/sessionStorage';
import useAuth from 'hooks/useAuth';
import { ReactComponent as Close } from 'assets/images/icon/close_black.svg';
import MobileSearchNav from './SearchNav/MobileSearchNav';
import group14 from 'assets/images/group-14@2x.png';
import group16 from 'assets/images/group-16@2x.png';
import ellipse14 from 'assets/images/Ellipse 14.png';

const MobileNav = ({ isClicked, handleMobileMenu, externalGallery }) => {
  const navigate = useNavigate();
  const userInfo = getItem(GET_INFO);
  const { disconnect } = useAuth();

  const [showLaunchAppPopup, setShowLaunchAppPopup] = useState(false);

  const MOBILE_NAV_PAGES = [
    { url: '/', name: 'Home' },
    { url: '/about', name: 'About' },
    { url: '/market', name: 'Market' },
    { url: '/artist', name: 'STO.RWA' },
    { url: '/news', name: 'News' },
    { url: '/exhibition', name: 'Magazine' },
    { url: '/user-board', name: 'Community' },
    { external: true, url: '', name: 'Launch App' },
  ];

  const handleLaunchAppClick = () => {
    // Update the state to show the popup
    setShowLaunchAppPopup(true);
  };

  const closeLaunchAppPopup = () => {
    setShowLaunchAppPopup(false);
  };

  const handleDisconnect = () => {
    navigate('/');
    disconnect();
  };

  return (
    <aside className={`mobile-menu-wrap max-width flex-1 overflow-y-scroll ${isClicked && 'activate-mobile'}`}>
      <div className="mobile-menu-list-wrapper flex-1 padding-bottom-32 responsive-background-width col align-center justify-between margin-center">
        <div className="max-width">
          <div className="mobile-menu-nav-header row max-width align-center justify-between">
            <MobileSearchNav />
            <div className="link centered bordered-black padding-12 border-50" onClick={handleMobileMenu}>
              <Close width={16} height={16} />
            </div>
          </div>
          <ul className="col align-start text-center">
            {MOBILE_NAV_PAGES.map(page => (
              <li className="menu-item inline-block" key={page.url + '_pc'}>
                {page.name === 'Launch App' ? (
                  // For "Launch App", show the popup
                  <span
                    onClick={handleLaunchAppClick}
                    className="name poppins black font-14 font-weight-600 primary-hover link padding-col-4 padding-row-8 border-radius-10"
                    style={{ backgroundColor: 'black', color: 'white' }}
                  >
                    {page.name}
                  </span>
                ) : (
                  // For other pages, navigate within the app
                  <span onClick={() => navigate(page.url)} className="name poppins font-18 font-weight-600 black primary-hover link">
                    {page.name}
                  </span>
                )}
              </li>
            ))}
            {showLaunchAppPopup && (
              <div className="popup">
                <div className="overlap-wrapper">
                  <div className="overlap">
                    <div className="overlap-group">
                      <img className="group" alt="Group" src={group14} />
                      <div className="overlap-group-wrapper">
                        <div className="div">
                          <div className="overlap-group-2">
                            <div className="ellipse" />
                            <div className="ellipse-2" />
                            <div className="ellipse-3" />
                            <div className="ellipse-4" />
                            <div className="ellipse-5" />
                            <div className="ellipse-6" />
                          </div>
                          <div className="ellipse-7" />
                        </div>
                      </div>
                      <img className="img" alt="Group" src={group16} />
                      <div className="enter-universe">ENTER UNIVERSE</div>
                      <div className="div-wrapper">
                        <div className="overlap-2">
                          <div className="ellipse-8" />
                          <div className="ellipse-9" />
                        </div>
                      </div>
                      <div className="group-2">
                        <div className="ellipse-10" />
                        <div className="ellipse-11" />
                        <div className="ellipse-12" />
                        <div className="ellipse-13" />
                        <div className="ellipse-14" />
                        <div className="ellipse-15" />
                      </div>
                      <img className="ellipse-16" alt="Ellipse" src={ellipse14} />
                      <div className="x-button" onClick={closeLaunchAppPopup}>
                        <div className="group-4">
                          <div className="overlap-group-3">
                            <div className="rectangle" />
                            <div className="rectangle-2" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="staking">
                      <div className="group-5">
                        <div className="NFT-staking-wrapper">
                          <a className="NFT-staking" href="https://nft-staking.unilapse.app" target="_blank" rel="noreferrer noopener">
                            NFT STAKING
                          </a>
                        </div>
                      </div>
                      <div className="group-3">
                        <div className="token-staking-wrapper">
                          <a className="token-staking" href="https://staking.unilapse.app" target="_blank" rel="noreferrer noopener">
                            TOKEN STAKING
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {userInfo ? (
              <>
                <li className="mobile-menu-list padding-col-12 link">
                  <Link to="/myPage" className="poppins black primary-hover font-24 font-weight-700" onMouseUp={handleMobileMenu} rel="nosublink">
                    My Page
                  </Link>
                </li>
                <li className="mobile-menu-list padding-col-12 link">
                  <Link to="/settings/account" className="poppins black primary-hover font-24 font-weight-700" onMouseUp={handleMobileMenu} rel="nosublink">
                    Account Setting
                  </Link>
                </li>
                {userInfo?.admin && (
                  <>
                    <li className="mobile-menu-list padding-col-12 link">
                      <Link to="/create" className="poppins black primary-hover font-24 font-weight-700" onMouseUp={handleMobileMenu} rel="nosublink">
                        Create
                      </Link>
                    </li>
                    <li className="mobile-menu-list padding-col-12 link">
                      <Link to="/minting" className="poppins black primary-hover font-24 font-weight-700" onMouseUp={handleMobileMenu} rel="nosublink">
                        Minting
                      </Link>
                    </li>
                  </>
                )}
                <li className="mobile-menu-list padding-col-12 link">
                  <button className="poppins black primary-hover font-24 font-weight-700" onMouseUp={handleMobileMenu} onClick={handleDisconnect}>
                    Disconnect
                  </button>
                </li>
              </>
            ) : null}
          </ul>
        </div>
        {!userInfo ? (
          <Link to="/connect" className="poppins white font-16" onMouseUp={handleMobileMenu} rel="nosublink">
            <div className="width-278 height-56 centered border-none border-radius-10 background-primary background-primary-hover link top-64">CONNECT</div>
          </Link>
        ) : null}
      </div>
    </aside>
  );
};

export default MobileNav;
